import { useState } from "react";

export default function Greeting({ bots, onDone }) {
  const [index, setIndex] = useState(0);

  const bot = bots[index];
  const isLast = index === bots.length - 1;

  const handleNext = () => {
    if (isLast) {
      onDone();
    } else {
      setIndex((i) => i + 1);
    }
  };

  return (
    <div className="Greeting">
      <div className="Greeting-Card">
        <img
          className="Greeting-Avatar"
          src={bot.config.image_url}
          alt={bot.config.name}
        />
        <div className="Greeting-Name">{bot.config.name}</div>
        <div className="Greeting-Author">{bot.config.author_name}</div>
        <div className="Greeting-Description">{bot.config.description}</div>

      </div>
      <div className="Greeting-Nav">
        <div className="Greeting-Dots">
          {bots.map((_, i) => (
            <div
              key={i}
              className={"Greeting-Dot" + (i === index ? " Active" : "")}
            />
          ))}
        </div>
        <button className="Greeting-Btn" onClick={handleNext}>
          {isLast ? "Начать игру" : "Следующий →"}
        </button>
      </div>
    </div>
  );
}
